import { SET_AUTH_USER, SET_USER_CLAIMS, SET_USER_DATA } from '../types'

const reducer = (state, action) => {
  switch (action.type) {
    case SET_AUTH_USER:
      return {
        ...state,
        authUser: action.payload,
        isUserAuthenticated: !!action.payload,
        authStateLoaded: true,
      }
    case SET_USER_DATA:
      return {
        ...state,
        userData: action.payload,
        userDataLoaded: true,
      }
    case SET_USER_CLAIMS:
      return {
        ...state,
        userClaims: action.payload,
        userClaimsLoaded: Boolean(action.payload),
      }
    default:
      return state
  }
}

export default reducer
